import { render, staticRenderFns } from "./CasePanel.vue?vue&type=template&id=4ee5382e&scoped=true&"
import script from "./CasePanel.vue?vue&type=script&lang=ts&"
export * from "./CasePanel.vue?vue&type=script&lang=ts&"
import style0 from "./CasePanel.vue?vue&type=style&index=0&id=4ee5382e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee5382e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
